import React from "react";
import Navbar from "./Navbar";
import Header from "./Header";
import Particles from "react-tsparticles";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  particlesCanvas: {
    position: "fixed", // fixed so it covers entire screen and stays behind
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: -1,
    opacity: 0.7,
    pointerEvents: "none",
  },
  navbar: {
    position: "relative",
    zIndex: 10,
  },
  header: {
    position: "relative",
    zIndex: 5,
  },
});

const Home = () => {
  const classes = useStyles();

  return (
    <>
      {/* Particle Background */}
      <div className={classes.particlesCanvas}>
        <Particles
          params={{
            particles: {
              number: {
                value: 80,
                density: {
                  enable: true,
                  value_area: 800,
                },
              },
              color: {
                value: "#ffffff",
              },
              shape: {
                type: "circle",
                stroke: {
                  width: 0,
                  color: "#000000",
                },
              },
              size: {
                value: 5,
                random: true,
              },
              opacity: {
                value: 0.5,
              },
              line_linked: {
                enable: true,
                distance: 150,
                color: "#ffffff",
                opacity: 0.4,
                width: 1,
              },
              move: {
                enable: true,
                speed: 2.5,
                direction: "none",
                out_mode: "out",
              },
            },
            interactivity: {
              events: {
                onhover: {
                  enable: true,
                  mode: "repulse",
                },
                onclick: {
                  enable: true,
                  mode: "push",
                },
                resize: true,
              },
              modes: {
                repulse: {
                  distance: 200,
                },
              },
            },
            retina_detect: true,
          }}
        />
      </div>

      {/* Actual Content */}
      <Navbar className={classes.navbar} />
      <Header className={classes.header} />
    </>
  );
};

export default Home;
